module.exports = __webpack_public_path__ + "static/media/burger_menu.20f8b7d6.svg";